/* "Use your current shoes" in the PDP size drawer (Andre, 2026-09-11: "Yeah, this is great. Push it live").
   Approved mock: preview/size-reco-pdp/ ; decisions: docs/handoffs/2026-09-11-size-guide-reco-proof.md
   Labels written by ChatGPT: copy/runs/20260911-171452-site-ui-r1-4cd0.json (in ~/pulse-project).

   The SAME matching as the size guide page (assets/pulse-size-reco.js; tests in preview/size-reco/test_reco.mjs),
   trimmed for a panel: brand + size only; the fit question appears ONLY when their size falls between two of
   ours; no width or second-pair questions. The answer lights the chart row, where the drawer's own Select
   button already sets the size in the buy box, so there is no new buy-box wiring.

   Our sizes come from the drawer's [data-psg-data] block (shop.metafields.custom.size_chart_new), never a copy.
   Other brands come from assets/pulse-size-brands.js, loaded the first time someone reaches for the link.
   Rendered on current-range products only (snippets/pulse-size-drawer.liquid).

   ONE QUESTION AT A TIME (Andre, 2026-09-13): brand, then women's or men's (its own dropdown, asked
   BEFORE the size), then size. Each step stays hidden until the one before it is answered. Arriving
   in this mode no longer opens the brand list: it used to focus the brand box, and focus opened the
   list. The list now opens when the customer taps or types in the box. */
(function () {
  var drawer = document.getElementById('SizeDrawer');
  if (!drawer) return;
  var psg = drawer.querySelector('[data-psg]');
  var shoes = drawer.querySelector('[data-sdr-shoes]');
  if (!psg || !shoes) return;
  var chart;
  try { chart = JSON.parse(psg.querySelector('[data-psg-data]').textContent); } catch (e) { return; }
  var toShoes = drawer.querySelector('[data-sdr-switch="shoes"]'), modeBox = drawer.querySelector('.sdr-mode');
  /* The chart the drawer names (data-default-range): 'new' on the current range,
     'original' on the clearance collection (2026-09-17), where the brand ladders
     answer on the original chart because the maths is foot length either way. */
  var RANGE = psg.getAttribute('data-default-range') || 'new';
  var BASE = Array.isArray(chart[RANGE]) && chart[RANGE].length ? chart[RANGE] : chart['new'];
  if (!Array.isArray(BASE) || !BASE.length) { if (modeBox) modeBox.hidden = true; else if (toShoes) toShoes.hidden = true; return; }

  function lab(v) { if (v === null || v === undefined || v === '') return ''; var f = parseFloat(v); return isNaN(f) || String(v).indexOf('-') > 0 ? String(v) : String(f); }
  function mm(cm) { return Math.round(parseFloat(cm) * 10); }
  var ROWS = [];
  BASE.forEach(function (r, i, a) {
    var hi = mm(r.cm), lo = i ? ROWS[i - 1].hi : hi - (a.length > 1 ? mm(a[1].cm) - hi : 4);
    ROWS.push({ usm: lab(r.usm), usw: lab(r.usw), uk: lab(r.uk), eu: lab(r.eu), lo: lo, hi: hi });
  });

  /* ---------- words (2026-09-15): the storefront's language from snippets/pulse-size-i18n.liquid, this English if absent ---------- */
  var T = (function () {
    var en = { original_range: "Pulse Dance Shoes' original range (Flow or Bianco)", original_note: 'The size you bought in Flow or Bianco.',
      card_title: 'Your Pulse Dance Shoes size', card_women: "Women's US [size]", card_men: "Men's US [size]", card_select: 'Select [size]',
      group_dance: 'Dance brands', group_other: 'All other brands', group_all: 'Brands', tag_ours: 'ours', tag_dance: 'dance',
      size_select: 'Select your size', size_select_in: 'Select your size in [brand]', size_choose: 'Choose', pick_brand_first: 'Pick a brand first',
      size_in_them: 'Your size in them', size_on_box: 'The size printed on the box', fit_q: 'How do they fit you?',
      fit_q_named: 'How does your [shoe] fit you?', women_lower: "women's", men_lower: "men's", box_use: 'Use [label].',
      wide_line: 'For a wider fit, choose Flow 2 Wide in the same size: a true 2E width with added volume around the toe box, so it has more room across the ball of the foot and toes.',
      measure_rather: 'We would rather measure than guess.', pairs_disagree: 'Those two pairs point to different feet.',
      covers_three: 'That size covers three of ours.', enter_length: 'Enter your foot length and we will give you an exact size.',
      smaller: 'That is smaller than our smallest size.', larger: 'That is larger than our largest size.',
      double_check: 'Measure your foot to double-check.', not_on_file: 'We do not have that size on file for [brand] yet.',
      measure_exact: 'Measure your foot and we will give you an exact size.', measure_instead: 'Measure my foot instead',
      drawer_covers_three: 'That size covers three of our sizes, so measure your foot instead.',
      drawer_not_on_file: 'We do not have that [brand] size yet.', sold_out: 'Sold out',
      too_wide: 'Your foot is too wide for this style, so we recommend [name].', viewing_wide: "You're viewing [self], a wide-fit style. Based on your measurements, we recommend our regular fit in [name].", viewing_regular: "You're viewing [self], a regular-fit style. Based on your measurements, we recommend our wide fit in [name].", youre_regular: "You're a regular fit", youre_wide: "You're a wide fit",
      recommended_size: 'Recommended size', also_fits: 'Also consider', feel_snug: 'A more supportive fit', feel_roomy: 'For more space across the toe and heel', line_regular: 'Regular fit', line_wide: 'Wide fit', border_short: 'Your foot sits between our regular and wide fit, so either will work.', choose_size: 'Choose this size', suits_regular: 'We recommend [name] in our regular fit.', verdict_h: 'Two sizes will fit you', two_options: 'You have two size options', recommended_fit: 'Recommended fit',
      border_intro: 'That is right on the line between our regular fit and our wide fit, so either will work. Choose by how you like a shoe to feel.',
      opt_up: 'Regular fit, half a size up', opt_regular: 'Regular fit, your size', opt_wide: 'Your size in a wide fit', or_word: 'or',
      tag_roomy: 'Roomier fit', tag_snug: 'Snugger fit', b_roomy: 'A more forgiving fit, with extra room around the toes',
      b_snug: 'A slimmer profile and a snug fit', b_top: "Your foot is at the top of your size, so the half size up won't feel long",
      this_style: 'This style', other_view: 'View [name]', other_note: '[name] is its own style. This opens it with your size selected.',
      other_note_wide_all: 'Flow 2 Wide is its own style, in black or white. This shows it in your size.', also_nova_volt: 'Also in Nova and Volt',
      notes: {}, box: {} };
    var el = psg.querySelector('[data-pulse-size-i18n]'), got = {};
    try { if (el) got = JSON.parse(el.textContent) || {}; } catch (e) {}
    for (var k in got) if (Object.prototype.hasOwnProperty.call(got, k) && got[k]) en[k] = got[k];
    return en;
  })();
  function tf(tpl, map) { return String(tpl).replace(/\[(\w+)\]/g, function (w, k) { return Object.prototype.hasOwnProperty.call(map, k) ? String(map[k]) : w; }); }
  /* "Nike men's 9", "Bloch 7": the shoe named in the fit question, in the order the English always used */
  function shoeName(brand, sys, men, shown) {
    var parts = [brand.name];
    if (sys === 'us') parts.push(men ? T.men_lower : T.women_lower); else if (sys) parts.push(sys.toUpperCase());
    parts.push(shown);
    return parts.join(' ');
  }

  /* ---------- brands ---------- */
  var brands = [], byName = {}, ordered = [], loaded = false, loading = false, waiters = [];
  function add(b) { brands.push(b); byName[b.name.toLowerCase()] = b; b.aliases.forEach(function (a) { byName[a.toLowerCase()] = b; }); }
  function loadBrands(cb) {
    if (loaded) { if (cb) cb(); return; }
    if (cb) waiters.push(cb);
    if (loading) return;
    loading = true;
    var s = document.createElement('script'); s.src = shoes.getAttribute('data-brands-src'); s.async = true;
    s.onload = function () {
      (window.PulseSizeBrands || []).forEach(function (x) {
        var rows = function (a) { return (a || []).map(function (r) { return { label: r[0], lo: r[1], hi: r[2], sys: { us: r[3], uk: r[4], eu: r[5] } }; }); };
        add({ id: x[0], name: x[1], aliases: x[2], group: x[3] === 'd' ? 'dance' : 'street', sizing: x[4], box_label: T.box[x[0]] || x[5], note: T.notes[x[0]] || x[6], systems: x[7], ladders: { women: rows(x[8].w), men: rows(x[8].m) } });
      });
      ordered = brands.slice().sort(function (a, b) { var g = { pulse: 0, dance: 1, street: 1 }; /* dance brands fold into the list (Andre, 2026-10-19) */ return g[a.group] - g[b.group] || a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }); });
      loaded = true; var w = waiters; waiters = []; w.forEach(function (f) { f(); });
    };
    s.onerror = function () { loading = false; };
    document.head.appendChild(s);
  }
  /* our original range as a brand, from the live chart: a repeat customer names the Flow or Bianco size they bought */
  if (RANGE !== 'original' && Array.isArray(chart.original) && chart.original.length) {
    var lad = { women: [], men: [] }, prevHi = null;
    chart.original.forEach(function (r, i, a) {
      var hi = mm(r.cm), lo = i ? prevHi : hi - (a.length > 1 ? mm(a[1].cm) - hi : 4); prevHi = hi;
      lad.women.push({ label: lab(r.usw), lo: lo, hi: hi, sys: { us: lab(r.usw), uk: lab(r.uk), eu: lab(r.eu) } });
      lad.men.push({ label: lab(r.usm), lo: lo, hi: hi, sys: { us: lab(r.usm), uk: lab(r.uk), eu: lab(r.eu) } });
    });
    var origAliases = ['Pulse', 'Pulse Dance Shoes', 'Flow', 'Flow original', 'Bianco', 'Flow White', 'Flow Black', 'Flow Onyx'];
    origAliases.push('Flow or Bianco (our original range)');
    if (T.original_range !== "Pulse Dance Shoes' original range (Flow or Bianco)") origAliases.push("Pulse Dance Shoes' original range (Flow or Bianco)");
    add({ id: 'pulse-original', name: T.original_range, group: 'pulse', sizing: 'us', box_label: '',
      note: T.original_note, systems: ['us', 'uk', 'eu'], ladders: lad,
      aliases: origAliases });
    ordered = brands.slice();
  }
  if (toShoes) {
    toShoes.addEventListener('pointerover', function () { loadBrands(); }, { once: true });
    toShoes.addEventListener('focus', function () { loadBrands(); }, { once: true });
  }

  /* ---------- logic ---------- */
  function scale() { if (state.gender) return state.gender; return psg.getAttribute('data-psg-scale') === 'men' ? 'men' : 'women'; }
  function overlap(a, b) { return Math.max(0, Math.min(a.hi, b.hi) - Math.max(a.lo, b.lo)); }
  function ladder(brand) { var l = brand.ladders, sc = scale(); return l[sc] && l[sc].length ? l[sc] : (l.women.length ? l.women : l.men); }
  function recommend(brand, label, fit) {
    var first = null; ladder(brand).forEach(function (r) { if (r.label === label) first = r; });
    if (!first) return { status: 'unknown' };
    var w = first.hi - first.lo, band = { lo: first.lo, hi: first.hi };
    if (fit === 'tight') band.lo = band.hi - Math.max(1, Math.round(w / 3));
    if (fit === 'roomy') band.hi = band.lo + Math.max(1, Math.round(w / 3));
    var c = ROWS.filter(function (r) { return overlap(r, band) > 0; });
    if (!c.length) return { status: 'out', small: band.hi <= ROWS[0].lo };
    if (c.length === 1) return { status: 'match', row: c[0] };
    if (c.length >= 3) return { status: 'measure' };
    var row = fit === 'tight' ? c[1] : fit === 'roomy' ? c[0] : (overlap(c[0], band) > overlap(c[1], band) ? c[0] : c[1]);
    return { status: 'between', row: row };
  }

  /* ---------- the panel ---------- */
  var brandIn = shoes.querySelector('[data-sdr-brand]'), list = shoes.querySelector('.sdr-list');
  var sizeSel = shoes.querySelector('[data-sdr-size]'), note = shoes.querySelector('[data-sdr-note]');
  var genderSel = shoes.querySelector('[data-sdr-gender]');
  var stepGender = shoes.querySelector('[data-sdr-step="gender"]'), stepSize = shoes.querySelector('[data-sdr-step="size"]');
  var fitBox = shoes.querySelector('[data-sdr-fit]'), fitLabel = shoes.querySelector('[data-sdr-fitlabel]'), result = shoes.querySelector('[data-sdr-result]');
  var resultWrap = shoes.querySelector('[data-sdr-resultwrap]');
  var modeBtns = drawer.querySelectorAll('.sdr-mode [data-sdr-switch]');
  var state = { brand: null, gender: '', label: '', fit: 'right', mode: 'foot', between: false };
  /* A page cached before 2026-09-13 has the old markup (no women's or men's step) but loads this script.
     For that page the drawer's own switch keeps answering the question beside the size, as it did. */
  var LEGACY = !genderSel;
  if (LEGACY) state.gender = psg.getAttribute('data-psg-scale') === 'men' ? 'men' : 'women';
  /* Open or close a step. Direction A's steps are .sdr-reveal (animated, and `inert` while closed so
     nothing inside can take focus); anything else, including a cached page's older markup, uses hidden. */
  function reveal(el, open) {
    if (!el) return;
    if (el.classList.contains('pss-reveal') || el.classList.contains('sdr-reveal')) { el.classList.toggle('is-open', !!open); el.inert = !open; }
    else el.hidden = !open;
  }
  /* reveal the next box only once the one above it is answered; answered boxes and numbers go ink */
  function steps() {
    reveal(stepGender, !!state.brand);
    reveal(stepSize, !!(state.brand && state.gender));
    brandIn.classList.toggle('is-done', !!state.brand);
    if (genderSel) genderSel.classList.toggle('is-done', !!state.gender);
    sizeSel.classList.toggle('is-done', !!(state.brand && state.gender && state.label));
    [['1', state.brand], ['2', state.gender], ['3', state.brand && state.gender && state.label]].forEach(function (x) {
      var el = shoes.querySelector('[data-sdr-n="' + x[0] + '"]'); if (el) el.classList.toggle('is-done', !!x[1]);
    });
  }

  var SYS = { us: 'US', uk: 'UK', eu: 'EU' };
  function thirds(v) { var s = String(v); if (/\.33$/.test(s)) return s.slice(0, -3) + '⅓'; if (/\.67$/.test(s)) return s.slice(0, -3) + '⅔'; return s; }
  function rowText(b, r) {
    var p = [];
    if (b.sizing === 'box') p.push(b.name.split(' ')[0] + ' ' + r.label);
    (b.sizing === 'uk' ? ['uk', 'eu', 'us'] : ['us', 'uk', 'eu']).forEach(function (k) {
      if (!r.sys || !r.sys[k] || (b.sizing === 'box' && r.sys[k] === r.label)) return;
      p.push(SYS[k] + ' ' + thirds(r.sys[k]));
    });
    return p.length ? p.join(' · ') : r.label;
  }
  function fillSizes() {
    var keepLabel = state.label;
    while (sizeSel.firstChild) sizeSel.removeChild(sizeSel.firstChild);
    if (!state.brand || !state.gender) { sizeSel.disabled = true; sizeSel.appendChild(new Option(sizeSel.getAttribute('data-ph'), '')); state.label = ''; return; }
    sizeSel.disabled = false;
    /* "Select your size in Bloch", never "Select box number" (Andre, 2026-09-13) */
    sizeSel.appendChild(new Option(tf(T.size_select_in, { brand: state.brand.name }), ''));
    var seen = {};
    ladder(state.brand).forEach(function (r) { var t = rowText(state.brand, r); if (!seen[t]) { seen[t] = 1; sizeSel.appendChild(new Option(t, r.label)); } });
    sizeSel.value = keepLabel; state.label = sizeSel.value;
  }

  function clearRows() { psg.querySelectorAll('tr.is-match').forEach(function (tr) { tr.classList.remove('is-match'); }); }
  function markRow(row) {
    psg.querySelectorAll('[data-psg-row]').forEach(function (tr) {
      if (lab(tr.getAttribute('data-usw')) === row.usw && lab(tr.getAttribute('data-usm')) === row.usm) {
        tr.classList.add('is-match'); var p = tr.querySelector('.pulse-sizedrawer__pick'); if (p) p.tabIndex = 0;
      }
    });
  }

  function render() {
    while (result.firstChild) result.removeChild(result.firstChild);
    clearRows();
    steps();
    if (!state.brand || !state.gender || !state.label) { reveal(fitBox, false); reveal(resultWrap, false); if (window.PulseSizeTrack) PulseSizeTrack.record('drawer-brand', null); return; }
    var r = recommend(state.brand, state.label, state.fit);
    /* only worth asking when the answer depends on it; once shown it stays for that pair */
    if (r.status === 'between') state.between = true;
    reveal(fitBox, state.between);
    var sys = state.brand.sizing === 'box' ? null : (state.brand.systems.indexOf(state.brand.sizing) >= 0 ? state.brand.sizing : state.brand.systems[0]);
    var sc = scale() === 'men' ? "men's" : "women's", row = null;
    ladder(state.brand).forEach(function (x) { if (x.label === state.label) row = x; });
    var shown = sys && row && row.sys[sys] ? row.sys[sys] : state.label;
    fitLabel.textContent = tf(T.fit_q_named, { shoe: shoeName(state.brand, sys, scale() === 'men', shown) });
    if (window.PulseSizeTrack) {
      var t = PulseSizeTrack, ctx = t.context();
      var theirs = state.brand.name + ' ' + (sys === 'us' ? sc + ' US ' : sys ? sys.toUpperCase() + ' ' : '') + shown;
      var ours = r.row ? t.pulseSize(r.row, scale()) : (r.status === 'measure' ? 'asked to measure' : r.status === 'out' ? 'outside our range' : 'size not on file');
      t.record('drawer-brand', {
        surface: 'product page', method: 'shoes I already own', market: ctx.market, product: ctx.product,
        brand: state.brand.name, brand_size: theirs, scale: scale(), fit: state.fit || 'right', status: r.status, pulse_size: ours,
        pulse_us_women: r.row ? r.row.usw : '', pulse_us_men: r.row ? r.row.usm : '', pulse_uk: r.row ? r.row.uk : '', pulse_eu: r.row ? r.row.eu : '',
        summary: theirs + ', fits ' + (state.fit || 'right') + ' -> Pulse ' + ours + ' (product page: ' + ctx.product + ')'
      });
    }
    var p = document.createElement('p'); p.className = 'sdr-answer';
    if (r.row && resultWrap) {
      markRow(r.row);
      result.appendChild(buildCard(r.row)); reveal(resultWrap, true);
      return;
    }
    if (r.row) {
      p.appendChild(document.createTextNode('Your size with us is '));
      var g = document.createElement('span'); g.className = 'sdr-sizes';
      var b = document.createElement('b'); b.textContent = sc + ' US ' + (scale() === 'men' ? r.row.usm : r.row.usw);
      g.appendChild(b); g.appendChild(document.createTextNode(' · UK ' + r.row.uk + ' · EU ' + r.row.eu + '.'));
      p.appendChild(g); result.appendChild(p); markRow(r.row); reveal(resultWrap, true);
      return;
    }
    p.textContent = r.status === 'out' ? (r.small ? T.smaller : T.larger)
      : r.status === 'measure' ? T.drawer_covers_three
      : tf(T.drawer_not_on_file, { brand: state.brand.name });
    result.appendChild(p); reveal(resultWrap, true);
  }

  /* The answer card, one builder for both paths. Its button carries the lit chart row's own data-size-pick, so
     the drawer's delegated Select handler sets the buy box exactly as the chart's Select does, sold out included. */
  function buildCard(row) {
    var men = scale() === 'men', ourSize = tf(men ? T.card_men : T.card_women, { size: men ? row.usm : row.usw });
    var card = document.createElement('div'); card.className = 'pss-card';
    var k = document.createElement('span'); k.className = 'sdr-banner sdr-banner--rec'; k.textContent = T.recommended_size;
    var v = document.createElement('span'); v.className = 'pss-card__v'; v.textContent = ourSize;
    var sub = document.createElement('span'); sub.className = 'pss-card__s'; sub.textContent = 'UK ' + row.uk + ' · EU ' + row.eu;
    card.appendChild(k); card.appendChild(v); card.appendChild(sub);
    var lit = psg.querySelector('tr.is-match [data-size-pick]');
    if (lit) {
      var cta = document.createElement('button'); cta.type = 'button'; cta.className = 'pss-card__cta';
      cta.setAttribute('data-size-pick', lit.getAttribute('data-size-pick'));
      if (lit.getAttribute('data-size-usw')) cta.setAttribute('data-size-usw', lit.getAttribute('data-size-usw'));
      cta.disabled = lit.disabled; cta.textContent = lit.disabled ? T.sold_out : T.choose_size;
      card.appendChild(cta);
    }
    return card;
  }

  /* ---------- MEASURE MY FOOT as steps (2026-09-13) ----------
     assets/pulse-size-guide.js still does the measuring and lights the row; it announces each outcome as
     `psg:answer`. Foot length is step 1; a match opens women's or men's (step 2); an answered step 2 opens the
     card. The women's or men's answer is ONE answer for both paths, so switching path never asks it twice. */
  var footStep = drawer.querySelector('[data-sdr-fn="1"]'), fGenderStep = drawer.querySelector('[data-sdr-fstep="gender"]');
  var fGenderSel = drawer.querySelector('[data-sdr-fgender]'), fResultWrap = drawer.querySelector('[data-sdr-fresultwrap]');
  var fResult = drawer.querySelector('[data-sdr-fresult]'), footWrap = psg.querySelector('.sdr-footstep .psg__inputwrap');
  var foot = { state: 'hint', row: null, cm: null };

  /* ---------- FOOT WIDTH (Andre, 2026-10-23) ----------
     The size guide's rule (assets/pulse-size-reco.js widthFit, ~/pulse-project/common/width_fit.py), on this chart's rows.
     Change the numbers there and here together. The field renders on current-range product pages only. */
  var widthField = drawer.querySelector('[data-sdr-widthfield]'), widthIn = drawer.querySelector('[data-sdr-fwidth]');
  var SIB = { wide: false, self: '', name: '', url: '', v: {} };
  try { var sj = drawer.querySelector('[data-sdr-sib]'); if (sj) SIB = JSON.parse(sj.textContent); } catch (e) {}
  var RATIO_REGULAR = 0.39, RATIO_UP = 0.409, RATIO_NARROW = 0.35, NEAR_MM = 2, BORDER_PTS = 1;
  function unitNow() { var on = psg.querySelector('[data-psg-unit].is-on'); return (on && on.getAttribute('data-psg-unit')) || 'cm'; }
  function widthCm() {
    if (!widthIn) return null;
    var v = parseFloat(String(widthIn.value || '').replace(',', '.'));
    if (isNaN(v) || v <= 0) return null;
    var c = Math.round((unitNow() === 'in' ? v * 2.54 : v) * 10) / 10;
    return c >= 6 && c <= 14 ? c : null;
  }
  function widthFit(row, cmLen, cmWid) {
    var rows = ROWS, i = -1;
    for (var k = 0; k < rows.length; k++) if (rows[k].usw === lab(row.usw) && rows[k].usm === lab(row.usm)) { i = k; break; }
    if (i < 0 || !cmLen || !cmWid) return null;
    var lmm = Math.round(cmLen * 10), wmm = Math.round(cmWid * 100) / 10, top = rows[i].hi, w;
    var below = i > 0 ? lmm - rows[i - 1].hi : null;
    if (wmm < RATIO_NARROW * lmm) w = below !== null && below <= NEAR_MM ? { fit: 'down', row: rows[i - 1], from: rows[i - 1] } : { fit: 'narrow', row: rows[i] };
    else {
      var atTop = top - lmm <= NEAR_MM && i + 1 < rows.length;
      if (wmm <= RATIO_REGULAR * top + 1e-9) w = { fit: 'regular', row: rows[i] };
      else if (atTop && wmm <= RATIO_UP * lmm + 1e-9) w = { fit: 'up', row: rows[i + 1], from: rows[i] };
      else w = { fit: 'wide', row: rows[i] };
      var up = { fit: 'up', row: rows[i + 1], from: rows[i] }, reg = { fit: 'regular', row: rows[i] }, wide = { fit: 'wide', row: rows[i] };
      /* two options only for a foot just OVER the Wide line; under it, regular only (Andre, 2026-10-24) */
      if (atTop && w.fit === 'wide' && (wmm / lmm - RATIO_UP) * 100 <= BORDER_PTS + 1e-9) w.border = [wide, up];
      else if (!atTop && w.fit === 'wide' && (wmm / top - RATIO_REGULAR) * 100 <= BORDER_PTS + 1e-9) w.border = [wide, reg];
    }
    return w;
  }
  /* keep "Flow 2" on one line in running text */
  function nb(t) { return String(t || '').replace(/Flow 2/g, 'Flow\u00a02'); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  var TAX = { '4': '17100', '4.5': '2940', '5': '2941', '5.5': '2942', '6': '17101', '6.5': '2943', '7': '2944', '7.5': '2945',
    '8': '17102', '8.5': '2946', '9': '2947', '9.5': '2948', '10': '17103', '10.5': '3010', '11': '3011', '11.5': '3012',
    '12': '17210', '12.5': '3013', '13': '3014', '13.5': '3015' };
  /* where the OTHER style is: the matching colourway with the size chosen, else Flow 2 Wide in both colours filtered to the size */
  function other(row) {
    if (SIB.url) { var id = SIB.v && SIB.v[String(row.usm)]; return { name: SIB.name, url: SIB.url + (id ? '?variant=' + id : '') }; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', tax = TAX[String(row.usm)];
    return { name: 'Flow 2 Wide',
      url: root + 'collections/wide-fit-dance-sneakers' + (tax ? '?filter.v.t.shopify.shoe-size=' + encodeURIComponent('gid://shopify/TaxonomyValue/' + tax) +
        '&filter.v.m.pulse.availability=In+stock&filter.v.m.pulse.availability=Pre-order' : '') };
  }
  /* the chart row's own Select, so this style's card sets the buy box exactly as the chart does, sold out included */
  function pickFor(row) {
    var hit = null;
    psg.querySelectorAll('tr[data-psg-row]').forEach(function (tr) { if (lab(tr.getAttribute('data-usm')) === row.usm && lab(tr.getAttribute('data-usw')) === row.usw) hit = tr.querySelector('[data-size-pick]'); });
    return hit;
  }
  function sizeCard(row, fit, note, withChip) {
    var men = scale() === 'men', ourSize = tf(men ? T.card_men : T.card_women, { size: men ? row.usm : row.usw });
    var roomy = fit === 'wide', mine = roomy === !!SIB.wide;
    var c = el('div', 'pss-card');
    /* Two options (Andre, 2026-10-23): a banner across the top of each card. The style they are on reads
       "Recommended fit"; the other option keeps its roomier / snugger label. No silhouettes of other styles. */
    /* Two options, simplified (Andre, 2026-10-23: "very convoluted and way too confusing"): each card reads like
       the one-answer card. Banner, the fit in one line, the size, one line on how it feels, one button. */
    if (withChip) {
      c.classList.add('sdr-opt');
      c.appendChild(el('span', 'sdr-banner ' + (mine ? 'sdr-banner--rec' : 'sdr-banner--also'), mine ? (T.option_1 || T.recommended_fit) : (T.option_2 || T.also_fits)));
      c.appendChild(el('span', 'sdr-youre', /* no "half a size up" (Andre, 2026-10-23): it had no reference point */ { regular: T.line_regular, wide: T.line_wide }[fit] || T.line_regular));
    } else { c.classList.add('pss-card--rec'); c.appendChild(el('span', 'sdr-banner sdr-banner--rec', T.recommended_size)); c.appendChild(el('span', 'sdr-youre', roomy ? T.youre_wide : T.youre_regular)); }
    c.appendChild(el('span', 'pss-card__v', ourSize));
    c.appendChild(el('span', 'pss-card__s', 'UK ' + row.uk + ' · EU ' + row.eu));
    var ticks = [];
    if (withChip) c.appendChild(el('span', 'pss-card__note', roomy ? T.feel_roomy : T.feel_snug));
    else if (note) c.appendChild(el('span', 'pss-card__note', note));
    var cta;
    if (mine) {
      var lit = pickFor(row);
      if (lit) {
        cta = el('button', 'pss-card__cta'); cta.type = 'button';
        cta.setAttribute('data-size-pick', lit.getAttribute('data-size-pick'));
        if (lit.getAttribute('data-size-usw')) cta.setAttribute('data-size-usw', lit.getAttribute('data-size-usw'));
        cta.disabled = lit.disabled; cta.textContent = lit.disabled ? T.sold_out : T.choose_size;
      }
    } else {
      var o = other(row);
      /* no "is its own style" line (Andre, 2026-10-23): the card and its button say where it goes */
      cta = el('a', 'pss-card__cta pss-card__cta--other', tf(T.other_view, { name: o.name }) + ' →'); cta.href = o.url;
    }
    if (ticks.length) { var ul = el('ul', 'pss-ticks'); ticks.forEach(function (t) { ul.appendChild(el('li', '', t)); }); c.appendChild(ul); }
    if (cta) c.appendChild(cta);
    return c;
  }
  /* One clear answer is the size alone: no ratio line and no fit sentence (Andre, 2026-10-23). */
  function widthAnswer(w) {
    if (!w.border) {
      /* The other fit: on a Wide page a foot that suits the regular fit, on a regular page a foot too wide for it.
         A message and a link, never a size card for this style (Andre, 2026-10-23). It says which fit they are and
         the size, and the button opens the other style with the size chosen (or the wide collection, filtered). */
      if ((w.fit === 'wide') !== !!SIB.wide) {
        var men = scale() === 'men', sz = tf(men ? T.card_men : T.card_women, { size: men ? w.row.usm : w.row.usw }), o = other(w.row);
        var c = el('div', 'pss-card'); c.appendChild(el('span', 'sdr-banner sdr-banner--rec', T.recommended_fit));
        c.appendChild(el('span', 'sdr-youre', SIB.wide ? T.youre_regular : T.youre_wide));
        c.appendChild(el('span', 'pss-card__v', sz)); c.appendChild(el('span', 'pss-card__s', 'UK ' + w.row.uk + ' · EU ' + w.row.eu));
        c.appendChild(el('p', 'sdr-suits', SIB.self ? tf(SIB.wide ? T.viewing_wide : T.viewing_regular, { self: nb(SIB.self), name: nb(o.name) }).replace(/-fit\b/g, '\u2011fit') : tf(SIB.wide ? T.suits_regular : T.too_wide, { name: o.name })));
        var a = el('a', 'pss-card__cta', tf(T.other_view, { name: o.name }) + ' →'); a.href = o.url; c.appendChild(a);
        return c;
      }
      return sizeCard(w.row, w.fit, '', false);
    }
    var v = el('section', 'pss-verdict');
    v.appendChild(el('h3', 'pss-verdict__h', T.two_options));
    v.appendChild(el('p', 'pss-verdict__p', T.border_short));
    /* the style they are on first, the other option under it */
    var mineFirst = w.border.slice().sort(function (a, b) { return ((b.fit === 'wide') === !!SIB.wide) - ((a.fit === 'wide') === !!SIB.wide); });
    mineFirst.forEach(function (opt, n) {
      if (n) { var or = el('div', 'pss-or'); or.appendChild(el('span', '', T.or_word)); v.appendChild(or); }
      v.appendChild(sizeCard(opt.row, opt.fit, '', true));
    });
    return v;
  }
  if (widthIn) {
    widthIn.addEventListener('input', function () { if (state.mode === 'foot') footRender(); });
    psg.querySelectorAll('[data-psg-unit]').forEach(function (b) { b.addEventListener('click', function () {
      widthIn.placeholder = widthIn.getAttribute(b.getAttribute('data-psg-unit') === 'in' ? 'data-ph-in' : 'data-ph-cm') || widthIn.placeholder;
      setTimeout(function () { if (state.mode === 'foot') footRender(); }, 0);
    }); });
  }

  function footRender() {
    if (!fGenderStep) return;
    var wcm = widthIn ? widthCm() : null;
    if (widthIn) widthIn.parentNode.classList.toggle('is-done', !!wcm);
    var matched = foot.state === 'match' && !!foot.row;   /* width optional (Andre, 2026-10-24): without it the length answers */
    reveal(fGenderStep, matched);
    if (footWrap) footWrap.classList.toggle('is-done', foot.state === 'match' && !!foot.row);
    if (footStep) footStep.classList.toggle('is-done', matched);
    fGenderSel.value = state.gender; fGenderSel.classList.toggle('is-done', !!state.gender);
    var n2 = drawer.querySelector('[data-sdr-fn="2"]'); if (n2) n2.classList.toggle('is-done', matched && !!state.gender);
    while (fResult.firstChild) fResult.removeChild(fResult.firstChild);
    if (matched && state.gender) {
      var w = widthIn ? widthFit(foot.row, foot.cm, wcm) : null;
      fResult.appendChild(w ? widthAnswer(w) : buildCard(foot.row)); reveal(fResultWrap, true);
    }
    else reveal(fResultWrap, false);
  }
  psg.addEventListener('psg:answer', function (e) {
    foot.state = e.detail.state; foot.row = e.detail.row; foot.cm = e.detail.cm;
    if (state.mode === 'foot') footRender();
  });
  if (fGenderSel) fGenderSel.addEventListener('change', function () {
    state.gender = fGenderSel.value === 'men' ? 'men' : fGenderSel.value === 'women' ? 'women' : '';
    if (genderSel) genderSel.value = state.gender;
    state.between = false; state.fit = 'right'; setFit('right'); state.label = '';
    /* set() repaints the table and re-answers through psg:answer when the scale actually changes */
    if (state.gender && window.PulseSizeScale) window.PulseSizeScale.set(state.gender);
    footRender();
  });

  var quietFocus = false;
  function setMode(mode, byKeyboard, quiet) {
    state.mode = mode; drawer.setAttribute('data-sdr-mode', mode);
    shoes.hidden = mode !== 'shoes';
    modeBtns.forEach(function (b) { var on = b.getAttribute('data-sdr-switch') === mode; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    /* The drawer's women's/men's switch stays beside the foot length. The shoes path asks the same
       question as its own step, and writes the answer through window.PulseSizeScale, the one owner. */
    var gender = psg.querySelector('.psg__gender'), home = psg.querySelector('.sdr-row--foot');
    if (gender && home && gender.parentNode !== home) home.appendChild(gender);
    clearRows();
    if (mode === 'shoes') {
      if (!quiet) loadBrands();
      if (genderSel) genderSel.value = state.gender;
      /* women's or men's may have been answered on the foot path: the size list follows it */
      if (state.brand) fillSizes();
      steps(); render();
      /* Keyboard users keep their place in the brand box; the list stays shut until they type or press
         the arrow keys. Pointer and touch users get no focus at all, so no list and no phone keyboard. */
      if (byKeyboard) { quietFocus = true; brandIn.focus(); }
    }
    else {
      var inp = psg.querySelector('[data-psg-input]');
      footRender();
      if (inp) { if (inp.value) inp.dispatchEvent(new Event('input')); if (!quiet && byKeyboard) inp.focus(); }
    }
  }
  drawer.querySelectorAll('[data-sdr-switch]').forEach(function (b) { b.addEventListener('click', function (e) { setMode(b.getAttribute('data-sdr-switch'), e.detail === 0); }); });

  /* typeahead: dance brands first, then every other brand A to Z */
  var items = [], active = -1;
  function close() { list.hidden = true; brandIn.setAttribute('aria-expanded', 'false'); active = -1; }
  function pick(b) { brandIn.value = b.name; close(); onBrand(); }
  function filter() {
    if (!loaded) loadBrands(filter);
    var q = brandIn.value.toLowerCase().trim();
    function hit(s) { return s.toLowerCase().split(/[\s.\-]+/).some(function (w) { return w.indexOf(q) === 0; }); }
    var qw = q.split(/\s+/).filter(Boolean);
      /* every word they type must start a word somewhere in the brand's name or aliases, so "pulse dance shoes flow" finds our original range */
      function words(b) { if (!b._w) b._w = [b.name].concat(b.aliases).join(' ').toLowerCase().split(/[\s.\-()]+/).filter(Boolean); return b._w; }
      var found = ordered.filter(function (b) { if (!qw.length) return true; var ws = words(b); return qw.every(function (x) { return ws.some(function (w) { return w.indexOf(x) === 0; }); }); });
    var dance = found.filter(function (b) { return b.group === 'pulse'; }), rest = found.filter(function (b) { return b.group !== 'pulse'; });
    items = dance.concat(rest);
    while (list.firstChild) list.removeChild(list.firstChild);
    items.forEach(function (b) {
      if (b === rest[0]) { var h = document.createElement('li'); h.className = 'sdr-group'; h.setAttribute('role', 'presentation'); h.textContent = dance.length ? T.group_other : T.group_all; list.appendChild(h); }
      var li = document.createElement('li'); li.className = 'sdr-item'; li.setAttribute('role', 'option');
      var n = document.createElement('span'); n.textContent = b.name; li.appendChild(n);
      if (b.group === 'pulse') { var t = document.createElement('small'); t.textContent = T.tag_ours; li.appendChild(t); }
      li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(b); });
      list.appendChild(li);
    });
    list.hidden = !items.length; brandIn.setAttribute('aria-expanded', items.length ? 'true' : 'false');
  }
  function onBrand() {
    var b = byName[brandIn.value.trim().toLowerCase()] || null;
    if (b !== state.brand) { state.brand = b; state.label = ''; state.fit = 'right'; state.between = false; setFit('right'); }
    fillSizes();
    var bits = []; if (b && b.box_label) bits.push(tf(T.box_use, { label: b.box_label })); if (b && b.note) bits.push(b.note);
    note.textContent = bits.join(' '); note.hidden = !bits.length;
    steps(); render();
  }
  brandIn.addEventListener('focus', function () { if (quietFocus) { quietFocus = false; return; } filter(); });
  brandIn.addEventListener('click', function () { if (list.hidden) filter(); });
  brandIn.addEventListener('input', function () { filter(); onBrand(); });
  brandIn.addEventListener('blur', function () { setTimeout(close, 120); });
  brandIn.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault(); if (list.hidden) filter();
      active = Math.max(0, Math.min(items.length - 1, active + (e.key === 'ArrowDown' ? 1 : -1)));
      var opts = list.querySelectorAll('.sdr-item'); opts.forEach(function (li, k) { li.classList.toggle('is-active', k === active); });
      if (opts[active]) opts[active].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && !list.hidden && active >= 0) { e.preventDefault(); pick(items[active]); }
    else if (e.key === 'Escape') { e.stopPropagation(); close(); }
  });
  sizeSel.addEventListener('change', function () { state.label = sizeSel.value; state.between = false; state.fit = 'right'; setFit('right'); render(); });
  function setFit(v) { shoes.querySelectorAll('[data-sdr-fitbtn]').forEach(function (b) { var on = b.getAttribute('data-sdr-fitbtn') === v; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
  shoes.querySelectorAll('[data-sdr-fitbtn]').forEach(function (b) { b.addEventListener('click', function () { state.fit = b.getAttribute('data-sdr-fitbtn'); setFit(state.fit); render(); }); });
  if (genderSel) genderSel.addEventListener('change', function () {
    state.gender = genderSel.value === 'men' ? 'men' : genderSel.value === 'women' ? 'women' : '';
    if (fGenderSel) fGenderSel.value = state.gender;
    state.between = false; state.fit = 'right'; setFit('right');
    if (state.gender && window.PulseSizeScale) window.PulseSizeScale.set(state.gender);
    steps(); fillSizes(); render();
  });
  /* women's/men's changed somewhere else (the scale is synced site-wide): an answered step follows it */
  new MutationObserver(function () {
    if (state.mode !== 'shoes') return;
    if (state.gender) { state.gender = psg.getAttribute('data-psg-scale') === 'men' ? 'men' : 'women'; if (genderSel) genderSel.value = state.gender; }
    fillSizes(); render();
  }).observe(psg, { attributes: true, attributeFilter: ['data-psg-scale'] });

  /* Opens on "Measure my foot" (Andre, 2026-09-14: "default to 'Measure My Foot' for the PDP and size guide
     page"); it opened on "My current shoes" from 2026-09-13. The brand file (~370 KB) is still fetched when the
     customer reaches for the size chart, so switching to the shoes path is instant. */
  if (modeBtns.length) {
    drawer.classList.add('sdr-a');
    setMode('foot', false, true);
    document.querySelectorAll('[data-pulse-chart-open]').forEach(function (el) {
      el.addEventListener('pointerover', function () { loadBrands(); }, { once: true });
      el.addEventListener('click', function () { loadBrands(); }, { once: true });
    });
  }
})();
